/**
 * @file Math Constants
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @private
 */
export const EPS = 0.0000001;
export const TwoPI = 2 * Math.PI;
export const DEG2RAD = Math.PI / 180;
export const RAD2DEG = 180 / Math.PI;
//# sourceMappingURL=math-constants.js.map